var Marionette = require('backbone.marionette');

var YesNoConfirmationModal = Marionette.View.extend({
    template: require('../../templates/common/yes-no-confirmation-modal.html'),

    ui: {
        modal: '#confirmation-modal',
        yesBtn: '#yes',
        noBtn: '#no'
    },

    events: {
        'click @ui.yesBtn': 'actionConfirmed',
        'click @ui.noBtn': 'actionDeclined'
    },

    templateContext: function () {
        var that = this;
        return {
            title: that.title || 'Confirmation',
            message: that.message || 'Are you sure?'
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'onRender', 'actionConfirmed', 'actionDeclined', 'clearUI', 'show', 'hide');
        if (options) {
            this.title = options.title;
            this.message = options.message;
            this.tag = options.tag;
        }
    },

    onRender: function () {
    },

    clearUI: function() {
        this.ui.modal.modal('hide');
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
    },

    actionConfirmed: function () {
        this.clearUI();
        this.triggerMethod('action:confirmed', {result: true, tag: this.tag});
    },

    actionDeclined: function() {
        this.clearUI();
        this.triggerMethod('action:confirmed', {result: false, tag: this.tag});
    },

    show: function() {
        this.ui.modal.modal({backdrop: 'static', keyboard: false});
    },

    hide: function() {
        this.clearUI();
    }
});

module.exports = YesNoConfirmationModal;


//////////////////
// WEBPACK FOOTER
// ./app/views/common/yes-no-confirmation-modal.js
// module id = 237
// module chunks = 0